<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    <span class="text-xl font-semibold text-text-default">
      {{ "MasterData.Users.AssignUser" | i18nextEager }} — {{ locationName() }}
    </span>
  </ng-template>

  <ng-template #content>
    @if (allUsers.isLoading()) {
      <app-spinner />
    } @else {
      <div class="flex flex-col gap-lg pt-lg">
        <div class="flex flex-col gap-xs">
          <span class="text-base font-medium text-text-default">
            {{ "MasterData.Users.SelectUser" | i18nextEager }} <span class="text-text-error">*</span>
          </span>

          <doka-search-field
            (valueChange)="searchText.set($event)"
            [placeholder]="'Common.Search' | i18nextEager"
            class="assign-user-modal-search w-full"
            data-testid="assign-user-search-field"
          />

          @if (submitted() && !selectedUserId()) {
            <span class="text-sm text-text-error">{{ "Common.Required" | i18nextEager }}</span>
          }
        </div>

        <div class="overflow-hidden rounded-md border border-border-ultra-light">
          <div class="max-h-80 overflow-y-auto p-2">
            @if (visibleUsers().length > 0) {
              @for (user of visibleUsers(); track user.id) {
                <button
                  type="button"
                  class="flex w-full items-center gap-base rounded-md px-4 py-3 text-left transition-colors"
                  [class.bg-background-highlight]="selectedUserId() === user.id"
                  [class.hover:bg-background-highlight-hover]="selectedUserId() === user.id"
                  [class.hover:bg-background-gray-ultra-light]="selectedUserId() !== user.id"
                  [attr.aria-pressed]="selectedUserId() === user.id"
                  (click)="selectUser(user.id)"
                  [attr.data-testid]="'assign-user-option-' + user.id"
                >
                  <div class="min-w-0 flex-1">
                    <div class="truncate text-base font-semibold text-text-default">{{ user.primaryLabel }}</div>
                    @if (user.secondaryLabel) {
                      <div class="truncate text-sm text-text-light">{{ user.secondaryLabel }}</div>
                    }
                  </div>

                  @if (selectedUserId() === user.id) {
                    <doka-icon name="check" class="shrink-0 text-xl text-icon-success-dark" />
                  }
                </button>
              }
            } @else {
              <div class="px-4 py-8 text-base text-text-light" data-testid="assign-user-no-users">
                {{
                  (availableUsers().length === 0 ? "MasterData.Users.NoAvailableUsers" : "Common.NoResults") | i18nextEager
                }}
              </div>
            }
          </div>
        </div>
      </div>
    }
  </ng-template>

  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button (click)="closeModal()" color="secondary" data-testid="assign-user-cancel-button">{{ "Common.Cancel" | i18nextEager }}</doka-button>
        <doka-button [disabled]="!selectedUserId()" (click)="submit()" color="primary" data-testid="assign-user-save-button">{{
          "Common.Save" | i18nextEager
        }}</doka-button>
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
